import { createFileRoute, Link } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";
import { MarketingLayout, useHydratedTranslation } from "@/components/marketing/Layout";
import { COMPETITORS } from "@/lib/comparisons";
import { useAutoTranslate } from "@/components/AutoTranslate";
import { ArrowRight } from "lucide-react";

export const Route = createFileRoute("/compare")({
  head: () =>
    buildSeo({
      path: "/compare",
      title: "Reality Twin vs. the alternatives — honest comparisons",
      description:
        "How Reality Twin compares to Chatbase, Botpress, Intercom, Drift, Tidio, Ada, Landbot and Custom GPTs — honest, side-by-side B2B AI comparisons.",
    }),
  component: ComparePage,
});

function ComparePage() {
  const t = useHydratedTranslation();
  const { out: catT } = useAutoTranslate(COMPETITORS.map((c) => c.category));
  return (
    <MarketingLayout>
      <div className="py-16 sm:py-24">
        <div className="mx-auto max-w-3xl px-6">
          <div className="font-mono-eyebrow">{t("routes.compare.eyebrow")}</div>
          <h1 className="mt-4 font-serif text-[40px] sm:text-[60px] leading-[1.02] tracking-[-0.03em]">
            {t("routes.compare.title")}
          </h1>
          <p className="mt-6 text-[18px] leading-[1.6] text-muted-foreground">
            {t("routes.compare.subtitle")}
          </p>
        </div>

        <div className="mx-auto max-w-4xl px-6 mt-12 grid sm:grid-cols-2 gap-4">
          {COMPETITORS.map((c, idx) => (
            <Link
              key={c.slug}
              to="/vs/$slug"
              params={{ slug: c.slug }}
              className="group hairline rounded-xl bg-card p-6 hover:bg-cream transition"
            >
              <div className="flex items-center justify-between gap-3">
                <div className="font-serif text-[22px] leading-tight">
                  Reality Twin vs. {c.name}
                </div>
                <ArrowRight
                  className="h-4 w-4 shrink-0 text-muted-foreground group-hover:translate-x-0.5 transition"
                  strokeWidth={2}
                />
              </div>
              <div className="mt-1 text-[13px] text-muted-foreground">
                {catT[idx] ?? c.category}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </MarketingLayout>
  );
}
